import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "send-fcm-modal",
  role: "dialog",
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  for: "title",
  class: "form-label"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = {
  for: "message",
  class: "form-label"
}
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = {
  for: "duration",
  class: "form-label"
}
const _hoisted_13 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

import { ref, computed, watch } from 'vue'
import FcmService from '@/services/FcmService'
import DriverRepository from '@/repositories/DriverRepository'
import { useI18n } from 'vue-i18n'
import ToastService from '@/services/ToastService'
import { Modal } from 'bootstrap'
import { DriverInterface } from '@/types/DriverInterface'
import { FCMNotification } from '@/types/FCMNotifications'
import DateHelper from '@/helpers/DateHelper'


export default /*@__PURE__*/_defineComponent({
  __name: 'SendFCMModal',
  props: {
    driver: {},
    driverIds: {}
  },
  emits: ["close", "sent"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const isBulkMode = computed(() => Array.isArray(props.driverIds) && props.driverIds.length > 0)
const error = ref<string | null>(null)
const fcmModal = ref<Modal | null>(null)
const { t } = useI18n()
const duration = ref<string>('15')
const message = ref<FCMNotification>({
  title: '',
  body: '',
  data: {
    duration: duration.value.toString(),
  }
})
const submitting = ref(false)

function close(): void {
  message.value = {
    title: '',
    body: '',
    data: {
      duration: duration.value.toString(),
    }
  }
  error.value = null
  emit('close')
}

watch(() => duration.value, (newDuration) => {
  if (newDuration === '' || isNaN(Number(newDuration)) || Number(newDuration) <= 0) {
    error.value = t('common.errors.invalid_duration')
    newDuration = '15'
  } else {
    error.value = null
  }
  message.value.data = {
    duration: newDuration.toString()
  }
})

async function sendMessage(): Promise<void> {
  submitting.value = true
  message.value.data = {
    duration: duration.value.toString(),
    timestamp: (DateHelper.unix() * 1000).toString()
  }
  if (isBulkMode.value) {
    DriverRepository.bulkSendMessage({
      driverIds: props.driverIds!,
      title: message.value.title,
      body: message.value.body,
      data: { duration: duration.value.toString() },
    }).then(() => {
      ToastService.toast(ToastService.SUCCESS, t('drivers.actions.sent_success'))
    }).catch((err) => {
      ToastService.toast(ToastService.ERROR, err.message)
      error.value = err.message
    }).finally(() => {
      close()
      submitting.value = false
    })
  } else if (props.driver) {
    FcmService.sendToDriver(props.driver.id, message.value).then(() => {
      ToastService.toast(ToastService.SUCCESS, t('drivers.actions.sent_success'))
    }).catch((err) => {
      ToastService.toast(ToastService.ERROR, err.message)
      error.value = err.message
    }).finally(() => {
      close()
      submitting.value = false
    })
  } else {
    FcmService.sendToAllDrivers(message.value).then(() => {
      ToastService.toast(ToastService.SUCCESS, t('drivers.actions.sent_success'))
    }).catch((err) => {
      ToastService.toast(ToastService.ERROR, err.message)
      error.value = err.message
    }).finally(() => {
      close()
      submitting.value = false
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(sendMessage, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, [
              (isBulkMode.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Send message to " + _toDisplayString(props.driverIds!.length) + " drivers", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(__props.driver ? _ctx.$t('drivers.actions.send_message_to', { name: __props.driver.name }) : _ctx.$t('drivers.actions.send_message_to_all')), 1)
                  ], 64))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: close
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.fields.title')), 1),
              _withDirectives(_createElementVNode("input", {
                id: "title",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message.value.title) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, message.value.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.fields.message')), 1),
              _withDirectives(_createElementVNode("textarea", {
                id: "message",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message.value.body) = $event)),
                required: "",
                rows: "3"
              }, null, 512), [
                [_vModelText, message.value.body]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.placeholders.duration')), 1),
              _withDirectives(_createElementVNode("input", {
                id: "duration",
                class: "form-control w-25",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((duration).value = $event)),
                required: "",
                type: "number"
              }, null, 512), [
                [_vModelText, duration.value]
              ])
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: close
            }, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: submitting.value
            }, [
              (submitting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
            ], 8, _hoisted_15)
          ])
        ], 32)
      ])
    ])
  ]))
}
}

})